import React from 'react';
import { string, func, shape, bool, number, oneOfType } from 'prop-types';
import { InputLabel } from '@ui-propulsion/react-components';
import { RadioButton, RadioGroup, CurrencyInput } from '@shared_modules/local-propulsion/components';
import ErrorMessage from '@shared_modules/rc-inline-error-message';
import { HOME_STATUS_EXPENSE_FIELD, HOME_STATUS_OPTIONS } from '../../constants';
import { VALID_HOME_STATUS_EXPENSE } from '@shared_modules/baui-constants';

import './styles.scss';

const LivingSituation = ({
  fieldName,
  validationErrors,
  onChange,
  homeStatusDefaultValue,
  handleBlur,
  onChangeExpense,
  homeStatusExpenseAmount,
  showRentField,
  pageName,
  expenseFieldName,
}) => {
  const ROOT_CLASS = 'LivingSituation';
  const hasHomeStatusError = validationErrors[fieldName];
  const homeStatusExpenseField = HOME_STATUS_EXPENSE_FIELD[homeStatusDefaultValue];

  return (
    <div className={`${ROOT_CLASS} ${pageName}`}>
      <legend>
        <InputLabel
          htmlFor={fieldName}
          error={hasHomeStatusError}
          className={`${ROOT_CLASS}-inputLabel`}
          component="div"
          required
        >
          Living Situation
        </InputLabel>
      </legend>
      <div className={`${ROOT_CLASS}-radio-wrapper`}>
        <RadioGroup name={fieldName} onChange={onChange} value={homeStatusDefaultValue}>
          {HOME_STATUS_OPTIONS.map(option => (
            <RadioButton
              inputProps={{}}
              name={fieldName}
              id={`${fieldName}-${option.value}`}
              key={option.value}
              {...option}
              error={hasHomeStatusError}
              labelProps={{
                id: `${fieldName}Label-${option.value}`,
                htmlFor: `${fieldName}-${option.value}`,
              }}
            />
          ))}
        </RadioGroup>
        {validationErrors[fieldName] && (
          <ErrorMessage validationErrors={validationErrors[fieldName]} dataQaIdPrefix={`${fieldName}`} />
        )}
      </div>
      {showRentField && VALID_HOME_STATUS_EXPENSE.includes(homeStatusDefaultValue) && (
        <div className={`${ROOT_CLASS}-rentAmount`}>
          <CurrencyInput
            name={expenseFieldName}
            label={homeStatusExpenseField.label}
            helperText={homeStatusExpenseField.helperText}
            onBlur={handleBlur}
            onChange={onChangeExpense}
            errors={validationErrors[expenseFieldName]}
            defaultValue={homeStatusExpenseAmount}
            aria-invalid={validationErrors[expenseFieldName]}
            allowDecimals
          />
        </div>
      )}
    </div>
  );
};

LivingSituation.propTypes = {
  fieldName: string,
  validationErrors: shape({}),
  onChange: func.isRequired,
  homeStatusDefaultValue: string,
  homeStatusExpenseAmount: oneOfType([number, string]),
  handleBlur: func,
  onChangeExpense: func,
  showRentField: bool,
  pageName: string,
  expenseFieldName: string,
};

LivingSituation.defaultProps = {
  fieldName: 'homeStatus',
  validationErrors: {},
  showRentField: true,
  homeStatusExpenseAmount: undefined,
  homeStatusDefaultValue: '',
  handleBlur: () => {},
  onChangeExpense: () => {},
  pageName: '',
  expenseFieldName: 'homeStatusExpense',
};

export default LivingSituation;

